import React from "react";
import ReactDOM from "react-dom/client";

import "react-toastify/dist/ReactToastify.css";
import "./index.css";

import App from "./app";

const root = document.getElementById("root");

ReactDOM.createRoot(root).render(<App />);
